import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export default function request(_x, _x2, _x3, _x4) {
  return _request.apply(this, arguments);
}

function _request() {
  _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engineKey, method, path, params) {
    var headers, response, json, message;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            headers = new Headers({
              "Content-Type": "application/json"
            });
            _context.next = 3;
            return fetch("https://search-api.swiftype.com/api/v1/public/".concat(path), {
              method: method,
              headers: headers,
              body: JSON.stringify(_objectSpread({
                engine_key: engineKey
              }, params)),
              credentials: "include"
            });

          case 3:
            response = _context.sent;
            _context.prev = 4;
            _context.next = 7;
            return response.json();

          case 7:
            json = _context.sent;
            _context.next = 12;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);

          case 12:
            if (!(response.status >= 200 && response.status < 300)) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", json);

          case 16:
            message = json && json.error ? json.error : response.status;
            throw new Error(message);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 10]]);
  }));
  return _request.apply(this, arguments);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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